module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('v-container', {
    style: ({
      backgroundColor: _vm.styles.general.background_color
    })
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-card', {
    staticClass: "new-green px-3 pt-3 pb-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('p', {
    staticClass: "text-white",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.pageData.awardedopportunities.sub_text) + "\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "bg-white px-2 pt-2 pb-2"
  }, [_c('v-layout', {
    staticClass: "mb-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md12": ""
    }
  }, [_c('b', [_vm._v("Filters")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "single-line": "",
      "placeholder": "NAICS"
    },
    model: {
      value: (_vm.filters.values.naics),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "naics", $$v)
      },
      expression: "filters.values.naics"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "light": "",
      "hide-details": "",
      "single-line": "",
      "placeholder": "PSC"
    },
    model: {
      value: (_vm.filters.values.psc),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "psc", $$v)
      },
      expression: "filters.values.psc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "light": "",
      "hide-details": "",
      "single-line": "",
      "placeholder": "Search"
    },
    model: {
      value: (_vm.filters.values.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "search", $$v)
      },
      expression: "filters.values.search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-menu', {
    staticClass: "mt-0",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.startmenu),
      callback: function($$v) {
        _vm.startmenu = $$v
      },
      expression: "startmenu"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "slot": "activator",
      "placeholder": "Start Date",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filters.values.startdate),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "startdate", $$v)
      },
      expression: "filters.values.startdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": save
          }
        }, [_vm._v("OK")])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.values.startdate),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "startdate", $$v)
      },
      expression: "filters.values.startdate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-menu', {
    staticClass: "mt-0",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.endmenu),
      callback: function($$v) {
        _vm.endmenu = $$v
      },
      expression: "endmenu"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "slot": "activator",
      "placeholder": "End Date",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filters.values.enddate),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "enddate", $$v)
      },
      expression: "filters.values.enddate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": save
          }
        }, [_vm._v("OK")])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.values.enddate),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "enddate", $$v)
      },
      expression: "filters.values.enddate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-3",
    staticStyle: {
      "margin-top": "-8px !important"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearFilters.apply(null, arguments)
      }
    }
  }, [_vm._v("Clear filters")])], 1)], 1), _vm._v(" "), _c('kendo-table', {
    ref: "kendoTable",
    attrs: {
      "kendo-schema": _vm.kendoSchema,
      "url": _vm.url
    },
    on: {
      "view": _vm.moreInfo,
      "change": _vm.selectRow
    }
  })], 1)])], 1), _vm._v(" "), _c('side-view-chat'), _vm._v(" "), _c('opportunities-modal', {
    attrs: {
      "dialog": _vm.dialog,
      "item": _vm.selectedItem
    }
  })], 1), _vm._v(" "), _c('site-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a798c4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AwardedOpportunitiesView.vue
// module id = 1665
// module chunks = 32